export default __webpack_public_path__ + "static/media/course2_L.ead63b32.gif";